module.exports = __webpack_public_path__ + "img/eyes_male_thin_mask.713d7e28.png";